import React from "react";
import { Link } from "react-router-dom";


const sidefooterlink = [
  { label: "About Company", to: "/about" },
  { label: "Privacy Policy", to: "/privacy-policy" },
  { label: "Terms & Conditions", to: "/terms-and-conditions" },
  { label: "Cookie Preferences", to: "/cookie-policy" },
  // { label: "Data Protection & Security", to: "/" },

];

const SidebarFooter = ({ }) => {
  return (
    <div className="col dashboard-right-footer-col">
      <div className="d-flex">
        <div className="dashboardfooter w-100 py-3">
          <div className="row g-0 text-center justify-content-center">
            <ul className="dashboardfooterlsit">
              {sidefooterlink.map((item) => (
                <li key={item.label}>
                  <Link
                    to={item.to}
                    className="d-inline-block text-decoration-none"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div
            className="text-center pt-3 ft-13 fw-medium"
            style={{
              color: "#2f343b",
            }}
          >
            <div>&copy; 2026 Industry &amp; People.</div>
            <div>All Rights Reserved.</div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SidebarFooter;